import { render, staticRenderFns } from "./basicHighlight.vue?vue&type=template&id=09512dd0&"
import script from "./basicHighlight.vue?vue&type=script&lang=js&"
export * from "./basicHighlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports